
export const HIGH_RISK_COUNTRIES = new Set([
  // FATF Black List (Call for Action)
  "KP", // North Korea
  "MM", // Myanmar (Burma)

  // FATF Grey List (Increased Monitoring) - Selected high-risk examples
  "SY", // Syria
  "YE", // Yemen
  "SS", // South Sudan

  // EU High-Risk Third Countries
  "AF", // Afghanistan
  "BD", // Bangladesh
  "BI", // Burundi
  "KH", // Cambodia
  "HT", // Haiti
  "IR", // Iran
  "JM", // Jamaica
  "JO", // Jordan
  "ML", // Mali
  "MZ", // Mozambique
  "NI", // Nicaragua
  "PK", // Pakistan
  "PA", // Panama
  "PH", // Philippines
  "SN", // Senegal
  "TZ", // Tanzania
  "TR", // Turkey
  "UG", // Uganda
  "VU", // Vanuatu
  "VN", // Vietnam
  "ZW"  // Zimbabwe
]);

export const CUSTOMER_COUNTRY_CODES = new Set([
    // Low Risk
    "AU", "AT", "BE", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", "HU", "IS", "IE", "LV", "LT", "LU", "NZ", "NO", "PL", "PT", 
    "RO", "SK", "SI", "ES", "SE",

    // Medium Risk
    "AL", "AR", "AM", "AZ", "BH", "BD", "BJ", "BT", "BN", "BG", "CV", "CA", "CL", "HR", "CY", "EG", "SZ", "ET", "FJ", "GA", 
    "GM", "GE", "GH", "GD", "GY", "ID", "IL", "IT", "JP", "JO", "KZ", "KR", "KW", "LS", "MG", "MW", "MV", "MT", "MR", "MU",
    "MN", "MA", "NP", "NL", "MK", "OM", "PY", "QA", "RW", "LC", "SM", "ST", "SA", "SC", "SL", "SG", "SB", "LK", "SR", "CH", 
    "TW", "TL", "TG", "TO", "GB", "US", "UY", "UZ", "ZM",

    // High Risk
    "AX", "DZ", "AS", "AD", "AO", "AI", "AQ", "AG", "AW", "BZ", "BM", "BO", "BQ", "BA", "BV", "BR", "IO", "BI", "KH", "KY", 
    "TD", "CN", "CX", "CC", "CO", "KM", "CG", "CK", "CR", "CI", "CW", "DJ", "DM", "DO", "EC", "SV", "GQ", "ER", "FK", "FO", 
    "GF", "PF", "TF", "GI", "GL", "GP", "GU", "GT", "GG", "GN", "HM", "VA", "HN", "HK", "IN", "IM", "JM", "JE", "KE", "KI", 
    "KG", "LA", "LR", "LI", "MO", "MY", "MH", "MQ", "YT", "MX", "FM", "MD", "MC", "ME", "MS", "NA", "NR", "NC", "NE", "NU", 
    "NF", "MP", "PW", "PS", "PG", "PE", "PN", "PR", "RE", "BL", "SH", "KN", "MF", "PM", "VC", "WS", "RS", "SX", "ZA", "GS", 
    "SJ", "TJ", "TH", "BS", "TK", "TN", "TR", "TM", "TC", "TV", "UA", "AE", "UM", "VG", "VI", "WF", "EH",
    "BS", "TK", "TN", "TR", "TM", "TC", "TV", "UA", "AE", "UM", "VG", "VI", "WF", "EH",

     // Black List
     "KP", "IR", "MM", "RU", "AF", "BB", "BY", "BW", "BF", "CM", "CD", "CU", "GW", "HT", "IQ", "LY", "ML", "MZ", "NI", "NG", 
     "PK", "PA", "PH", "SN", "SS", "SY", "TZ", "TT", "UG", "VU", "VE", "VN", "YE", "CF", "LB", "SO", "SD", "ZW",

]);

export const NON_FATF_COUNTRIES = new Set([
  "AF", "BD", "BI", "KH", "HT", "IR", "JM", "JO", "ML", "MZ", "NI", "PK", "PA", "PH", 
  "SN", "TZ", "TR", "UG", "VU", "VN", "ZW"  
]);

export const FATF_COUNTRIES = new Set([
  // Europe
  "AT", "BE", "CH", "CZ", "DE", "DK", "ES", "FI", "FR", "GB", "GR", "IE",
  "IS", "IT", "LU", "NL", "NO", "PL", "PT", "SE", "TR",
  // Americas
  "AR", "BR", "CA", "MX", "US",
  // Asia-Pacific
  "AU", "CN", "HK", "IN", "JP", "KR", "MY", "NZ", "SG", "TH",
  // Middle East & Africa
  "IL", "RU", "SA", "ZA",
  // Additional FATF members
  "AE", "ID", "PH"
]);

// IBAN validation utility
export function getIbanCountryCode(iban: string): string | null {
  if (!iban || iban.length < 2) {
    return null;
  }
  return iban.substring(0, 2).toUpperCase();
}

// Helper functions for country names
export function getCustomerCountryName(countryCode: string | null): string {
  if (!countryCode) {
    return "Unknown";
  }

  const customerCountryNames: Record<string, string> = {
    // Low Risk
      "AU": "Australia", "AT": "Austria", "BE": "Belgium", "CZ": "Czechia", "DK": "Denmark", "EE": "Estonia",
      "FI": "Finland", "FR": "France", "DE": "Germany", "GR": "Greece", "HU": "Hungary", "IS": "Iceland", 
      "IE": "Ireland", "LV": "Latvia", "LT": "Lithuania", "LU": "Luxembourg", "NZ": "New Zealand", "NO": "Norway",
      "PL": "Poland", "PT": "Portugal", "RO": "Romania", "SK": "Slovakia", "SI": "Slovenia", "ES": "Spain", "SE": "Sweden",

      // Medium Risk
      "AL": "Albania",
      "AR": "Argentina",
      "AM": "Armenia",
      "AZ": "Azerbaijan",
      "BH": "Bahrain",
      "BD": "Bangladesh",
      "BJ": "Benin",
      "BT": "Bhutan",
      "BN": "Brunei Darussalam",
      "BG": "Bulgaria",
      "CV": "Cabo Verde",
      "CA": "Canada",
      "CL": "Chile",
      "HR": "Croatia",
      "CY": "Cyprus",
      "EG": "Egypt",
      "SZ": "Eswatini",
      "ET": "Ethiopia",
      "FJ": "Fiji",
      "GA": "Gabon",
      "GM": "Gambia",
      "GE": "Georgia",
      "GH": "Ghana",
      "GD": "Grenada",
      "GY": "Guyana",
      "ID": "Indonesia",
      "IL": "Israel",
      "IT": "Italy",
      "JP": "Japan",
      "JO": "Jordan",
      "KZ": "Kazakhstan",
      "KR": "Korea (the Republic of)",
      "KW": "Kuwait",
      "LS": "Lesotho",
      "MG": "Madagascar",
      "MW": "Malawi",
      "MV": "Maldives",
      "MT": "Malta",
      "MR": "Mauritania",
      "MU": "Mauritius",
      "MN": "Mongolia",
      "MA": "Morocco",
      "NP": "Nepal",
      "NL": "Netherlands",
      "MK": "North Macedonia",
      "OM": "Oman",
      "PY": "Paraguay",
      "QA": "Qatar",
      "RW": "Rwanda",
      "LC": "Saint Lucia",
      "SM": "San Marino",
      "ST": "Sao Tome and Principe",
      "SA": "Saudi Arabia",
      "SC": "Seychelles",
      "SL": "Sierra Leone",
      "SG": "Singapore",
      "SB": "Solomon Islands",
      "LK": "Sri Lanka",
      "SR": "Suriname",
      "CH": "Switzerland",
      "TW": "Taiwan",
      "TL": "Timor-Leste",
      "TG": "Togo",
      "TO": "Tonga",
      "GB": "United Kingdom",
      "US": "United States of America",
      "UY": "Uruguay",
      "UZ": "Uzbekistan",
      "ZM": "Zambia",

      // High Risk
      "AX": "Åland Islands",
      "DZ": "Algeria",
      "AS": "American Samoa",
      "AD": "Andorra",
      "AO": "Angola",
      "AI": "Anguilla",
      "AQ": "Antarctica",
      "AG": "Antigua and Barbuda",
      "AW": "Aruba",
      "BZ": "Belize",
      "BM": "Bermuda",
      "BO": "Bolivia",
      "BQ": "Bonaire, Sint Eustatius and Saba",
      "BA": "Bosnia and Herzegovina",
      "BV": "Bouvet Island",
      "BR": "Brazil",
      "IO": "British Indian Ocean Territory",
      "BI": "Burundi",
      "KH": "Cambodia",
      "KY": "Cayman Islands",
      "TD": "Chad",
      "CN": "China",
      "CX": "Christmas Island",
      "CC": "Cocos (Keeling) Islands",
      "CO": "Colombia",
      "KM": "Comoros",
      "CG": "Congo",
      "CK": "Cook Islands",
      "CR": "Costa Rica",
      "CI": "Côte d'Ivoire",
      "CW": "Curaçao",
      "DJ": "Djibouti",
      "DM": "Dominica",
      "DO": "Dominican Republic",
      "EC": "Ecuador",
      "SV": "El Salvador",
      "GQ": "Equatorial Guinea",
      "ER": "Eritrea",
      "FK": "Falkland Islands",
      "FO": "Faroe Islands",
      "GF": "French Guiana",
      "PF": "French Polynesia",
      "TF": "French Southern Territories",
      "GI": "Gibraltar",
      "GL": "Greenland",
      "GP": "Guadeloupe",
      "GU": "Guam",
      "GT": "Guatemala",
      "GG": "Guernsey",
      "GN": "Guinea",
      "HM": "Heard Island and McDonald Islands",
      "VA": "Holy See",
      "HN": "Honduras",
      "HK": "Hong Kong",
      "IN": "India",
      "IM": "Isle of Man",
      "JM": "Jamaica",
      "JE": "Jersey",
      "KE": "Kenya",
      "KI": "Kiribati",
      "KG": "Kyrgyzstan",
      "LA": "Lao People's Democratic Republic",
      "LR": "Liberia",
      "LI": "Liechtenstein",
      "MO": "Macao",
      "MY": "Malaysia",
      "MH": "Marshall Islands",
      "MQ": "Martinique",
      "YT": "Mayotte",
      "MX": "Mexico",
      "FM": "Micronesia",
      "MD": "Moldova",
      "MC": "Monaco",
      "ME": "Montenegro",
      "MS": "Montserrat",
      "NA": "Namibia",
      "NR": "Nauru",
      "NC": "New Caledonia",
      "NE": "Niger",
      "NU": "Niue",
      "NF": "Norfolk Island",
      "MP": "Northern Mariana Islands",
      "PW": "Palau",
      "PS": "Palestine",
      "PG": "Papua New Guinea",
      "PE": "Peru",
      "PN": "Pitcairn",
      "PR": "Puerto Rico",
      "RE": "Réunion",
      "BL": "Saint Barthélemy",
      "SH": "Saint Helena, Ascension and Tristan da Cunha",
      "KN": "Saint Kitts and Nevis",
      "MF": "Saint Martin (French part)",
      "PM": "Saint Pierre and Miquelon",
      "VC": "Saint Vincent and the Grenadines",
      "WS": "Samoa",
      "RS": "Serbia",
      "SX": "Sint Maarten (Dutch part)",
      "ZA": "South Africa",
      "GS": "South Georgia and the South Sandwich Islands",
      "SJ": "Svalbard and Jan Mayen",
      "TJ": "Tajikistan",
      "TH": "Thailand",
      "BS": "The Bahamas",
      "TK": "Tokelau",
      "TN": "Tunisia",
      "TR": "Turkey",
      "TM": "Turkmenistan",
      "TC": "Turks and Caicos Islands",
      "TV": "Tuvalu",
      "UA": "Ukraine",
      "AE": "United Arab Emirates",
      "UM": "United States Minor Outlying Islands",
      "VG": "Virgin Islands (British)",
      "VI": "Virgin Islands (U.S.)",
      "WF": "Wallis and Futuna",
      "EH": "Western Sahara",

      // Black List
      "KP": "Democratic People's Republic of Korea",
      "IR": "Iran",
      "MM": "Myanmar",
      "RU": "Russian Federation",
      "AF": "Afghanistan",
      "BB": "Barbados",
      "BY": "Belarus",
      "BW": "Botswana",
      "BF": "Burkina Faso",
      "CM": "Cameroon",
      "CD": "Congo (the Democratic Republic of the)",
      "CU": "Cuba",
      "GW": "Guinea Bissau",
      "HT": "Haiti",
      "IQ": "Iraq",
      "LY": "Libya",
      "ML": "Mali",
      "MZ": "Mozambique",
      "NI": "Nicaragua",
      "NG": "Nigeria",
      "PK": "Pakistan",
      "PA": "Panama",
      "PH": "Philippines",
      "SN": "Senegal",
      "SS": "South Sudan",
      "SY": "Syria",
      "TZ": "Tanzania, the United Republic of",
      "TT": "Trinidad and Tobago",
      "UG": "Uganda",
      "VU": "Vanuatu",
      "VE": "Venezuela",
      "VN": "Viet Nam",
      "YE": "Yemen",
      "CF": "Central African Republic",
      "LB": "Lebanon",
      "SO": "Somalia",
      "SD": "Sudan",
      "ZW": "Zimbabwe"
  };

  return customerCountryNames[countryCode] || countryCode;
}

export function getCountryName(countryCode: string | null): string {
  if (!countryCode) {
    return "Unknown";
  }

  const countryNames: Record<string, string> = {
    "AL": "Albania",
    "AM": "Armenia",
    "AZ": "Azerbaijan",
    "BA": "Bosnia and Herzegovina",
    "BY": "Belarus",
    "EG": "Egypt",
    "GE": "Georgia",
    "IQ": "Iraq",
    "JO": "Jordan",
    "KZ": "Kazakhstan",
    "LB": "Lebanon",
    "LY": "Libya",
    "MD": "Moldova",
    "ME": "Montenegro",
    "MK": "North Macedonia",
    "PS": "Palestine",
    "RS": "Serbia",
    "TN": "Tunisia",
    "UA": "Ukraine",
    "UZ": "Uzbekistan",
    "XK": "Kosovo"
  };

  return countryNames[countryCode] || countryCode;
}

export function determineRiskLevel(debtorCountry: string | null, creditorCountry: string | null, amount: number): string {
  // FATF Black List countries = CRITICAL risk
  const blackListCountries = new Set(["KP", "MM", "IR", "SY"]);

  const involvesBlackList =
    (debtorCountry && blackListCountries.has(debtorCountry)) ||
    (creditorCountry && blackListCountries.has(creditorCountry));

  if (involvesBlackList) {
    return "CRITICAL";
  }

  // Both parties from high-risk countries = CRITICAL
  if (debtorCountry && creditorCountry &&
    HIGH_RISK_COUNTRIES.has(debtorCountry) &&
    HIGH_RISK_COUNTRIES.has(creditorCountry)) {
    return "CRITICAL";
  }

  if (debtorCountry && creditorCountry &&
    CUSTOMER_COUNTRY_CODES.has(debtorCountry) &&
    CUSTOMER_COUNTRY_CODES.has(creditorCountry)) {
    return "HIGH";
  }

  // High amount (>50k) = HIGH risk, otherwise ELEVATED
  if (amount > 50000) {
    return "HIGH";
  }

  return "ELEVATED";
}

